import { render, staticRenderFns } from "./ReturnBagReporting.vue?vue&type=template&id=09f27bf7&"
import script from "./ReturnBagReporting.vue?vue&type=script&lang=js&"
export * from "./ReturnBagReporting.vue?vue&type=script&lang=js&"
import style0 from "./ReturnBagReporting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports